import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=cd37ce66&scoped=true&"
import script from "./DashboardCards.vue?vue&type=script&lang=js&"
export * from "./DashboardCards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCards.vue?vue&type=style&index=0&id=cd37ce66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37ce66",
  null
  
)

export default component.exports